export default "__VITE_ASSET__7c2a143a__"